// 会员
export default [
  {
    path: '/member',
    name: 'member',
    component: () => import ('@/components/page/member/member')
  },
  {
    path: '/memberDetailPay',
    name: 'memberDetailPay',
    component: () => import ('@/components/page/member/memberDetailPay')
  },
  {
    path: '/memberDetailCharge',
    name: 'memberDetailCharge',
    component: () => import ('@/components/page/member/memberDetailCharge')
  },

  {
    path: '/memberSearch',
    name: 'memberSearch',
    component: () => import ('@/components/page/member/memberSearch')
  },
  {
    path: '/memberDetail',
    name: 'memberDetail',
    component: () => import ('@/components/page/member/memberDetail')
  },
  {
    path: '/memberRegister',
    name: 'memberRegister',
    component: () => import ('@/components/page/member/memberRegister')
  },

  // 卡券核销
  // import CouponUse from '@/components/page/CouponUse'
  {
    path: '/CouponUse',
    name: 'CouponUse',
    component: () => import ('@/components/page/member/coupon/CouponUse')
  },
  {
    path: '/CouponUseSetting',
    name: 'CouponUseSetting',
    component: () => import ('@/components/page/member/coupon/CouponUseSetting')
  }, {
    path: '/CouponSearch',
    name: 'CouponSearch',
    component: () => import ('@/components/page/member/coupon/CouponSearch')
  },
]



// WEBPACK FOOTER //
// ./src/router/modules/member.js